import React from 'react';
import {
  Col,
  Row,
  Modal,
  Form,
  Input,
  Button,
} from 'antd';
import {
  ArrowLeftOutlined,
  SaveOutlined,
} from '@ant-design/icons';
import FormSubmitControls from 'components/FormSubmitCustomControls';
import { useDispatch, useSelector } from 'react-redux';
import { SET_OBSERVACIONES, SET_PIN_PADRON_COMENTARIO } from 'store/reducers/caja';
import PropTypes from 'prop-types';

const ModalObservaciones = ({ callback }) => {
  const dispatch = useDispatch();
  const padron = useSelector(({ caja }) => caja.pinPadronComentario);
  const [form] = Form.useForm();

  const onCancel = (values) => {
    dispatch({ type: SET_PIN_PADRON_COMENTARIO });
    form.resetFields();
    callback(values);
  };

  const onFinish = () => {
    const { observaciones } = form.getFieldsValue();
    dispatch({
      type: SET_OBSERVACIONES,
      payload: {
        padronKey: padron.key,
        observaciones,
      },
    });
    onCancel(observaciones);
  };

  const saveControl = {
    text: 'Guardar',
    icon: <SaveOutlined />,
    onClick: () => onFinish(),
  };

  const backControl = {
    text: 'Regresar',
    icon: <ArrowLeftOutlined />,
    onClick: onCancel,
  };

  const getControls = () => [backControl, saveControl];

  return (
    <Modal
      footer={null}
      closable={false}
      open={!!padron}
      title={(
        <FormSubmitControls
          label="Agregar Observación"
          controls={getControls()}
        />
      )}
    >
      <Row>
        <Col span={24}>
          <Form
            form={form}
            layout="vertical"
            onFinish={() => onFinish()}
          >
            <Col span={24}>
              <Form.Item
                name="observaciones"
                label="Observaciones"
                hasFeedback
              >
                <Input.TextArea
                  autoSize={{ minRows: 4, maxRows: 4 }}
                  allowClear
                />
              </Form.Item>
            </Col>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </Modal>
  );
};
ModalObservaciones.propTypes = {
  callback: PropTypes.func,
};

ModalObservaciones.defaultProps = {
  callback: () => {},
};

export default ModalObservaciones;
